import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import { ActivePagePathProps } from "components/apiDocs/ApiSidebar/ApiSidebar";
import Icon from "components/components/Icon/Icon";
import useToggle from "hooks/useToggle";
import React from "react";
import { Link } from "react-router-dom";
import routeConstants, { apiDocsRouteSuffixes } from "utils/routeConstants";

import {
  StyledGettingStartedContainer,
  StyledButton,
  StyledCard,
  StyledDiv,
  StyledHeader,
  StyledOption,
  Title,
} from "./style";

const GettingStartedDropdown: React.FC<ActivePagePathProps> = ({
  activePagePath,
}) => {
  const [expanded, toggleExpanded] = useToggle(
    activePagePath === apiDocsRouteSuffixes.introduction ||
      activePagePath === apiDocsRouteSuffixes.guidance
  );

  return (
    <StyledGettingStartedContainer>
      <StyledCard>
        <StyledHeader
          className="card-header"
          onClick={toggleExpanded}
          data-test-id="api-dropdown-header"
        >
          <Title className="card-header-title">Getting Started</Title>
          <StyledButton
            type="button"
            className="card-header-icon"
            data-test-id="expander-button"
            aria-label={`Getting started more options`}
          >
            <Icon iconName={expanded ? faAngleUp : faAngleDown} />
          </StyledButton>
        </StyledHeader>
        <StyledDiv className={classnames({ expanded })}>
          <div className="content">
            <Link to={routeConstants.apiDocsIntroduction}>
              <StyledOption
                className={classnames({
                  "is-active":
                    activePagePath === apiDocsRouteSuffixes.introduction,
                })}
              >
                Introduction
              </StyledOption>
            </Link>
            <Link to={routeConstants.apiDocsGuidance}>
              <StyledOption
                className={classnames({
                  "is-active": activePagePath === apiDocsRouteSuffixes.guidance,
                })}
              >
                Guidance
              </StyledOption>
            </Link>
          </div>
        </StyledDiv>
      </StyledCard>
    </StyledGettingStartedContainer>
  );
};

export default GettingStartedDropdown;
